import Vue from 'vue'
import Vuex from "vuex";
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import jQuery from 'jquery'
window.jQuery = window.$ = jQuery
global.jQuery = jQuery

import money from 'v-money'
import VueLazyLoad from 'vue-lazyload'
import VueMask from 'v-mask'
import vueDebounce from 'vue-debounce'
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VModal from 'vue-js-modal'
Vue.use(VModal)
Vue.use(VueMask)
Vue.use(vueDebounce)
Vue.use(Vuex);

Vue.use(money, {precision: 4})
Vue.use(VueLazyLoad)
Vue.config.productionTip = false

Vue.directive('uppercase', {
	update (el) {
		el.value = el.value.toUpperCase()
	},
})

Vue.component('Datepicker', VueDatepickerUi)

const store = new Vuex.Store({
	state:{
	busca: null,
	filtro: null,
	filtroRapido:null
	},
	mutations:{
	change(state,payload){
		state.busca = payload;
	},
	changeFiltro(state,payload){
		state.filtro = payload;
		state.filtroRapido = null;
	},
	changeFiltroRapido(state,payload){
		state.filtroRapido = payload;
	},

	}
  });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
